export default __webpack_public_path__ + "static/media/ImgMain.dae821ce.jpg";